import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Message20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_875)'>
      <path
        d='M7 10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10C5 9.44771 5.44772 9 6 9C6.55228 9 7 9.44771 7 10Z'
        fill='currentColor'
      />
      <path
        d='M11 10C11 10.5523 10.5523 11 10 11C9.44771 11 9 10.5523 9 10C9 9.44771 9.44771 9 10 9C10.5523 9 11 9.44771 11 10Z'
        fill='currentColor'
      />
      <path
        d='M14 11C14.5523 11 15 10.5523 15 10C15 9.44771 14.5523 9 14 9C13.4477 9 13 9.44771 13 10C13 10.5523 13.4477 11 14 11Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 0.25C4.61527 0.25 0.250047 4.61522 0.250047 10C0.250047 12.5639 1.24042 14.8972 2.85779 16.6371L0.544765 18.404C-0.0124355 18.8296 0.298871 19.75 1.00005 19.75H10C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25ZM1.75005 10C1.75005 5.44365 5.4437 1.75 10 1.75C14.5564 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5564 18.25 10 18.25H3.21736L4.45533 17.3043C4.82351 17.0231 4.84546 16.4585 4.50023 16.1495C2.81122 14.6378 1.75005 12.4433 1.75005 10Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_875'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Message20.displayName = 'Message20';
export default Message20;
